// tslint:disable no-shadowed-variable // ;FIXME: ;TODO: `state` var is shadowed?
import { MutationTree, GetterTree, ActionTree, Module } from 'vuex';
import { RootState } from '@/store';
import * as api from '@/api';
import { AxiosResponse } from 'axios';
import { DataListItem, DataViewItem, DataSettings, ResponseData } from '@/types';
import { historyPushQuery } from '@/utils/router';
import { navigationQueryName } from '@/utils';

export interface DataManagementState {
  content: DataListItem[];
  settings: DataSettings;
  currentDataViewItem: DataViewItem;
  currentRegisterId: DataListItem['id'];
  navigatedListIndexes: string[];
  enableCopyLinkButton: boolean;
  iframeUrlQuery: string;
  registerParentListItem: DataListItem;
  navigatedLists: Array<DataListItem | DataListItem[]>;
}

const state: DataManagementState = {
  content: [] as DataListItem[],
  settings: {} as DataSettings,
  currentDataViewItem: {} as DataViewItem,
  currentRegisterId: 0,
  navigatedListIndexes: [],
  enableCopyLinkButton: false,
  iframeUrlQuery: '',
  registerParentListItem: {} as DataListItem,
  navigatedLists: [],
};

const getters: GetterTree<DataManagementState, RootState> = {
  listTitles(state: DataManagementState): {[key: number]: string} {
    return state.settings && state.settings.titles || {};
  },
  themeColor(state: DataManagementState): CSSStyleDeclaration['color'] {
    if (state.settings && state.settings.theme_colour) {
      return state.settings.theme_colour;
    } else return '#464871';
  },
  bgColor(state: DataManagementState): CSSStyleDeclaration['color'] {
    return state.settings && state.settings.bg_colour || '#fff';
  },
  cardBgColor(state: DataManagementState): CSSStyleDeclaration['color'] {
    return state.settings && state.settings.card_bg_colour || '#fff';
  },
};

const mutations: MutationTree<DataManagementState> = {
  ADD_DATA(state: DataManagementState, data: ResponseData): void {
    if (data.content) {
      state.content = data.content;
    }
    if (data.settings) {
      state.settings = data.settings;
    }
  },
  SET_LANG(state: DataManagementState, data: ResponseData): void {
    if (data.settings && data.settings.lang) {
      state.settings.lang = data.settings.lang;
    }
  },
  SET_CURRENT_DATA_VIEW_ITEM(state: DataManagementState, data: DataViewItem): void {
    state.currentDataViewItem = data;
  },
  SET_IFRAME_URL_QUERY(state: DataManagementState, query: string): void {
    state.iframeUrlQuery =  query;
  },
  SET_REGISTER_PARENT_LIST_ITEM(state: DataManagementState, listItem: DataListItem): void {
    state.registerParentListItem = listItem;
  },
  ADD_NAVIGATED_LIST_INDEX(state: DataManagementState, index: string | number): void {
    let leveledIndex: string | number = index;
    if (typeof leveledIndex === 'number') {
      const level: number = state.navigatedListIndexes.length + 1;
      leveledIndex = `${level}-${index}`;
    }
    if (state.navigatedListIndexes.indexOf(leveledIndex) === -1) {
      state.navigatedListIndexes.push(leveledIndex);
    }
    // setTimeout(() => {
    //   historyPushQuery(navigationQueryName, state.navigatedListIndexes.toString());
    // }, 200);
  },
  SET_NAVIGATED_LISTS(state: DataManagementState, dataList: DataListItem | DataListItem[]): void {
    state.navigatedLists.push(dataList);
  },
  CLEAR_NAVIGATED_LISTS(state: DataManagementState): void {
    state.navigatedLists = [];
  },
  REMOVE_LAST_NAVIGATED_LIST_INDEX(state: DataManagementState): void {
    state.currentRegisterId = 0;
    state.navigatedListIndexes.pop();
    historyPushQuery(navigationQueryName, '');
  },
  SET_REGISTER_ID(state: DataManagementState, registerId: DataListItem['id'] & number): void {
    state.currentRegisterId = registerId;
    historyPushQuery(navigationQueryName, String(state.currentRegisterId));
  },
  ENABLE_COPY_LINK_BUTTON(state: DataManagementState, isEnable: boolean): void {
    state.enableCopyLinkButton = isEnable;
  },
};

const actions: ActionTree<DataManagementState, RootState> = {
  async fetchDataList({ commit, state }, dataQuery: string): Promise<void> {
    if (state.content.length === 0) {

      let dataUrl: string = 'https://agendium-media-public.s3-eu-west-1.amazonaws.com/media/statements/' + dataQuery;
      if (dataQuery.includes('https')) {
        dataUrl = dataQuery;
      }

      const res: AxiosResponse<ResponseData> = await api.getDataList(dataUrl);
      if (res && res.data) {
        commit('ADD_DATA', res.data);
        commit('SET_LANG', res.data);
      }
    }
  }
};

const dataManagement: Module<DataManagementState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export default dataManagement;
